<template>
  <div class="projectTable">
    <div class="top-table">
      <el-table :data="tableList" ref="multipleTable"
                :header-cell-style="{background:'#F3F7FE',color:'#566087',textAlign:'center',padding:'0',height:'48px','font-weight':'bold'}"
                :cell-style="{height:'48px' }" height="100%" border style="width: 100%">

        <el-table-column type="index" :index="indexMethod" width="55" align="center"
                         :label="$t('projectV2.index')">
        </el-table-column>
        <el-table-column prop="" :show-overflow-tooltip="true" align="center"
                         :label="$t('newProjectV2.langPair')">
          <template slot-scope="{row}">
            <div>
              {{ $i18n.locale === 'zh' ?row.langDesc.replace('>'," — "):$langCase[row.sourceLang] + ' — '+ $langCase[row.targetLang]}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="transCompleteNum" :show-overflow-tooltip="true" align="center"
                         :label="$t('fileManagement.myProject')">
        </el-table-column>

      </el-table>
    </div>
    <div class="project-pagination">
      <el-pagination layout="prev, pager, next,sizes" :pager-count="5" :total="total"
                     :page-sizes="[10, 20, 30, 40]" :page-size="params.rows"
                     @current-change="handleCurrentChange" :current-page="params.page"
                     @size-change="handleSizeChange" ref="pagination">
      </el-pagination>
    </div>
  </div>

</template>

<script>
import { fileQueryPage } from "@/services/statistics"
export default {
  name: "taskTable",
  data () {
    return {
      params: {
        userId: JSON.parse(localStorage.userInfo).id,
        page: 1,
        rows: 10
      },
      tableList: [],
      total: 0,
    }
  },
  mounted () {
    this.queryPage()
  },
  methods: {
    handleSizeChange (currentSize) {
      this.params.rows = currentSize
      this.params.page = 1
      this.queryPage()
    },
    handleCurrentChange (currentPage) {
      this.params.page = currentPage
      this.queryPage()
    },
    indexMethod (index) {
      return index + 1
    },
    async queryPage () {
      let params = this.params
      const { success, list, totalRows } = await fileQueryPage(params)
      if (success) {
        this.tableList = list
        this.total = totalRows
      }
    }
  },
  watch: {

  },

}
</script>

<style lang="less" scoped>
.projectTable {
  width: 100%;
  height: 100%;
  .top-table {
    width: 100%;
    height: calc(100% - 62px);
  }
  .project-pagination {
    text-align: center;
    /deep/ .el-pagination {
      box-sizing: border-box;
      height: 28px;
      margin-top: 15px;
      padding: 0;

      button {
        display: inline-block;
        min-width: 30px;
        height: 28px;
        box-sizing: border-box;
      }

      .el-pagination__sizes {
        line-height: 0;
      }

      .btn-prev,
      .btn-next {
        box-sizing: border-box;
        width: 30px !important;
        padding: 0;
        border: 1px solid #c0cccc;
        border-radius: 3px;
      }

      .btn-prev {
        margin: 0 10px 0 5px;
      }
      .btn-next {
        margin: 0 5px;
      }
      .el-pager {
        li {
          min-width: 30px;
          height: 28px;
          border: 1px solid #c0cccc;
          border-radius: 3px;
          margin: 0 10px 0 5px;
        }
        .active {
          border: 1px solid #0087fc;
          color: #0078fc;
        }
      }
    }
  }
}
</style>